import { useState, useEffect } from "react";
import "../utilities/utilities.scss";
import "../nxt_ai_compatibility/compatibility.css";
import { __ } from "@wordpress/i18n";
import nxtds_icons from "../../dashIcon";
import { nxtdash_save_data } from "../../apicall";
import { ToastContainer, toast, Slide } from "react-toastify";

var nexterCustLink = nxtext_ajax_object?.dashData?.adminUrl || "";

var Theme_cstm_crds = [
	{
		key: "ai-integration-key",
		name: __("Manage API Keys", "the-plus-addons-for-block-editor"),
		crd_desc: __(
			"Manage, update, or view your API keys for connected AI providers.",
			"the-plus-addons-for-block-editor"
		),
		popDesc: __(
			"Configure your AI provider settings including API keys, model selection, and token limits for text and image generation.",
			"the-plus-addons-for-block-editor"
		),
		read_link:
			"https://nexterwp.com/docs/add-ai-integration-key-in-wordpress/",
		cust_link: nexterCustLink + "admin.php?page=nxt_code_snippets",
		doclink: "https://nexterwp.com/",
		formField: {
			key: "ai-integration-key",
			label: __("AI Settings", "the-plus-addons-for-block-editor"),
		},
	},
	{
		key: "ai-Context-key",
		name: __("Custom Context", "the-plus-addons-for-block-editor"),
		crd_desc: __(
			"Set the writing style, tone, and site-specific instructions. This context will be applied to all AI prompts to deliver more accurate and brand-aligned output.",
			"the-plus-addons-for-block-editor"
		),
		popDesc: __(
			"Define your business context and targeted audience to help AI generate more relevant and personalized content.",
			"the-plus-addons-for-block-editor"
		),
		read_link: "https://nexterwp.com/docs/add-ai-Context-key-in-wordpress/",
		cust_link: nexterCustLink + "admin.php?page=nxt_code_snippets",
		doclink: "https://nexterwp.com/",
		formField: {
			key: "ai-Context-key",
			label: __(
				"AI Context Settings",
				"the-plus-addons-for-block-editor"
			),
		},
	},
];
const isPro =
	String(nxtext_ajax_object?.pro).trim() === "1" ||
	String(nxtext_ajax_object?.tpgb_pro).trim() === "1";

const AI_Compatibility = ({ isProPopupVisible, setIsProPopupVisible }) => {
	const [enabledSettings, setEnabledSettings] = useState(() => {
		const extraSettings = nxtext_ajax_object?.dashData?.extOption || {};
		const aiSettings = extraSettings.nxtAiSettings || {};

		const defaultSettings = {
			"ai-integration-key": {
				switch:
					aiSettings.aiIntegrationEnabled !== undefined
						? Boolean(aiSettings.aiIntegrationEnabled)
						: true, // ✅ Already defaults to true
				values: {
					nxtAiModel: aiSettings.nxtAiModel || "chatgpt",
					chatgpt: {
						apiKey: aiSettings.chatgptApiKey || "",
						textMaxTokens: aiSettings.chatgptTextMaxTokens || 4096,
						enableText:
							aiSettings.chatgptEnableText !== undefined
								? Boolean(aiSettings.chatgptEnableText)
								: true, // ✅ Default to true
						enableImage:
							aiSettings.chatgptEnableImage !== undefined
								? Boolean(aiSettings.chatgptEnableImage) &&
								  Boolean(isPro)
								: Boolean(isPro),
						isKeyVerified: Boolean(aiSettings.chatgptKeyVerified),
					},
					gemini: {
						apiKey: aiSettings.geminiApiKey || "",
						textMaxTokens: aiSettings.geminiTextMaxTokens || 4096,
						imageMaxTokens: aiSettings.geminiImageMaxTokens || 2048,
						enableText:
							aiSettings.geminiEnableText !== undefined
								? Boolean(aiSettings.geminiEnableText)
								: true, // ✅ Default to true
						enableImage:
							aiSettings.geminiEnableImage !== undefined
								? Boolean(aiSettings.geminiEnableImage) &&
								  Boolean(isPro)
								: Boolean(isPro),
						isKeyVerified: Boolean(aiSettings.geminiKeyVerified),
					},
				},
			},
			"ai-Context-key": {
				switch: true,
				values: {
					businessContext: aiSettings.businessContext || "",
					targetedAudience: aiSettings.targetedAudience || "",
				},
			},
		};

		return defaultSettings;
	});

	const [extType, setExtType] = useState("");
	const [isPopupVisible, setIsPopupVisible] = useState(false);
	const [popupData, setPopupData] = useState(null);
	const [selectedModel, setSelectedModel] = useState("chatgpt");
	const [isValidatingKeys, setIsValidatingKeys] = useState(false);
	const [verifiedModel, setVerifiedModel] = useState(null);
	const [keyValidationResults, setKeyValidationResults] = useState({
		chatgpt: null,
		gemini: null,
	});

	const CustomSuccessToast = ({ message = "Successfully Saved" }) => (
		<div className="nxt_success_toast">
			<span className="nxt_success_icon_cover">
				<span className="nxt_success_check_icon">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="18"
						height="18"
						fill="none"
						viewBox="0 0 18 18"
					>
						<g clipPath="url(#a)">
							<path
								fill="#0BAA60"
								d="M8.194.022a9.163 9.163 0 0 0-4.758 1.894c-.687.529-1.578 1.522-2.093 2.332-.222.348-.655 1.236-.81 1.658a10.94 10.94 0 0 0-.451 1.758c-.11.686-.11 1.99 0 2.676.158.972.409 1.754.835 2.623.465.948.948 1.62 1.723 2.399.779.774 1.452 1.257 2.4 1.722.87.426 1.652.676 2.625.834.687.11 1.99.11 2.678 0a8.894 8.894 0 0 0 2.625-.834c.948-.465 1.621-.948 2.4-1.723.775-.778 1.258-1.45 1.723-2.398.31-.63.465-1.042.634-1.676.222-.845.275-1.306.275-2.285 0-.98-.053-1.44-.275-2.286a8.07 8.07 0 0 0-.634-1.676c-.465-.947-.948-1.62-1.723-2.398-.779-.775-1.452-1.257-2.4-1.722a8.761 8.761 0 0 0-2.607-.828c-.518-.08-1.674-.12-2.167-.07Z"
							/>
							<path
								fill="#fff"
								d="M13.722 5.135c.176.056.447.32.521.514a.98.98 0 0 1-.021.722c-.113.229-5.913 5.983-6.174 6.127a.844.844 0 0 1-.803-.003c-.148-.077-2.819-2.469-3.274-2.93a.87.87 0 0 1-.264-.651c.007-.532.398-.891.927-.856.127.01.282.042.342.077.095.046 1.874 1.648 2.452 2.201l.166.162 2.635-2.63c1.449-1.444 2.682-2.652 2.746-2.684.243-.123.461-.137.747-.049Z"
							/>
						</g>
						<defs>
							<clipPath id="a">
								<path fill="#fff" d="M0 18h18V0H0z" />
							</clipPath>
						</defs>
					</svg>
				</span>
				<span className="nxt_success_text">
					{__(message, "the-plus-addons-for-block-editor")}
				</span>
			</span>
			<span
				className="nxt_success_close_icon_cover"
				onClick={() => toast.dismiss()}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					fill="none"
					viewBox="0 0 20 20"
				>
					<path
						fill="#000"
						d="m11.474 10 3.977 3.977-1.473 1.473L10 11.473 6.023 15.45 4.55 13.977 8.527 10 4.55 6.022 6.023 4.55 10 8.527l3.978-3.978 1.473 1.473L11.474 10Z"
					/>
				</svg>
			</span>
		</div>
	);

	const CustomWarnToast = ({
		message = "Please enable AI Integration first",
	}) => (
		<div className="nxt_success_toast">
			<span className="nxt_success_icon_cover">
				<span className="nxt_success_check_icon">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						fill="none"
						viewBox="0 0 24 24"
					>
						<path
							fill="#e17100"
							d="M12 2.098a2.8 2.8 0 0 1 2.296 1.196l.098.151.002.004 8.47 14.14.007.012a2.8 2.8 0 0 1-2.395 4.199H3.521a2.8 2.8 0 0 1-2.394-4.2l.007-.011 8.47-14.14.001-.004A2.8 2.8 0 0 1 12 2.098m0 1.6a1.2 1.2 0 0 0-1.026.577L2.512 18.4A1.203 1.203 0 0 0 3.538 20.2h16.923a1.202 1.202 0 0 0 1.028-1.795l-8.464-14.13-.088-.127a1.2 1.2 0 0 0-.937-.45m.009 12.452a.85.85 0 1 1 0 1.7h-.01a.85.85 0 1 1 0-1.7zm-.01-7.95a.8.8 0 0 1 .8.8v4a.8.8 0 1 1-1.6 0V9a.8.8 0 0 1 .8-.8"
						/>
					</svg>
				</span>
				<span className="nxt_success_text">
					{__(message, "the-plus-addons-for-block-editor")}
				</span>
			</span>
			<span
				className="nxt_success_close_icon_cover"
				onClick={() => toast.dismiss()}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					fill="none"
					viewBox="0 0 20 20"
				>
					<path
						fill="#000"
						d="m11.474 10 3.977 3.977-1.473 1.473L10 11.473 6.023 15.45 4.55 13.977 8.527 10 4.55 6.022 6.023 4.55 10 8.527l3.978-3.978 1.473 1.473L11.474 10Z"
					/>
				</svg>
			</span>
		</div>
	);

	const CustomErrorToast = ({ message = "Failed to save toggle state" }) => (
		<div className="nxt_success_toast">
			<span className="nxt_success_icon_cover">
				<span className="nxt_success_check_icon">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						fill="none"
						viewBox="0 0 24 24"
					>
						<path
							fill="#fc4032"
							d="M11.999 1.2c5.965 0 10.8 4.835 10.8 10.8s-4.835 10.8-10.8 10.8-10.8-4.835-10.8-10.8S6.034 1.2 12 1.2m0 1.6a9.2 9.2 0 1 0 0 18.4 9.2 9.2 0 0 0 0-18.4m.01 12.35a.85.85 0 1 1 0 1.7h-.01a.85.85 0 1 1 0-1.7zm-.01-7.95a.8.8 0 0 1 .8.8v4a.8.8 0 1 1-1.6 0V8a.8.8 0 0 1 .8-.8"
						/>
					</svg>
				</span>
				<span className="nxt_success_text">
					{__(message, "the-plus-addons-for-block-editor")}
				</span>
			</span>
			<span
				className="nxt_success_close_icon_cover"
				onClick={() => toast.dismiss()}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					fill="none"
					viewBox="0 0 20 20"
				>
					<path
						fill="#000"
						d="m11.474 10 3.977 3.977-1.473 1.473L10 11.473 6.023 15.45 4.55 13.977 8.527 10 4.55 6.022 6.023 4.55 10 8.527l3.978-3.978 1.473 1.473L11.474 10Z"
					/>
				</svg>
			</span>
		</div>
	);

	const handleOpenPopup = (data) => {
		// For ai-integration-key, check if toggle is enabled
		if (
			data.key === "ai-integration-key" &&
			!enabledSettings[data.key]?.switch
		) {
			toast.warning("Please enable AI Integration first");
			return;
		}

		setExtType(data.key);
		setPopupData(data);

		// Set the currently selected model from settings only for AI Integration
		if (data.key === "ai-integration-key") {
			const currentModel =
				enabledSettings["ai-integration-key"]?.values?.nxtAiModel ||
				"chatgpt";
			setSelectedModel(currentModel);
		}

		setIsPopupVisible(true);
	};

	const handleClosePopup = () => {
		// 1️⃣ Always close PRO popup first
		if (isProPopupVisible) {
			setIsProPopupVisible(false);
			return;
		}

		// 2️⃣ Then close normal popup
		if (isPopupVisible) {
			setIsPopupVisible(false);
			setPopupData(null);
		}
	};

	const handleCheckboxChange = async (e, key, opt) => {
		const isChecked = e.target.checked;

		// Update local state first
		const updateSwitch = { ...enabledSettings };
		if (!updateSwitch[key]) {
			updateSwitch[key] = { switch: false, values: {} };
		}
		updateSwitch[key]["switch"] = isChecked;
		setEnabledSettings(updateSwitch);

		// Save to backend
		try {
			const aiIntegrationSettings =
				updateSwitch["ai-integration-key"].values;
			const chatgptSettings = aiIntegrationSettings.chatgpt;
			const geminiSettings = aiIntegrationSettings.gemini;
			const contextData = updateSwitch["ai-Context-key"].values;

			// ✅ MERGE with existing extOption data to preserve other settings
			const existingData = nxtext_ajax_object?.dashData?.extOption || {};

			const dataToSend = {
				action: "tpgb_connection_data_save",
				"submit-key": "Save",
				tpgb_connection_data: JSON.stringify({
					...existingData,
					nxtAiSettings: {
						aiIntegrationEnabled: isChecked,
						nxtAiModel:
							aiIntegrationSettings.nxtAiModel || "chatgpt",
						chatgptApiKey: chatgptSettings.apiKey,
						chatgptTextMaxTokens: chatgptSettings.textMaxTokens,
						chatgptEnableText: chatgptSettings.enableText,
						chatgptEnableImage: chatgptSettings.enableImage,
						chatgptKeyVerified: chatgptSettings.isKeyVerified,
						geminiApiKey: geminiSettings.apiKey,
						geminiTextMaxTokens: geminiSettings.textMaxTokens,
						geminiImageMaxTokens: geminiSettings.imageMaxTokens,
						geminiEnableText: geminiSettings.enableText,
						geminiEnableImage: geminiSettings.enableImage,
						geminiKeyVerified: geminiSettings.isKeyVerified,
						businessContext: contextData.businessContext,
						targetedAudience: contextData.targetedAudience,
					},
				}),
				nonce_tpgb_connection_data: nxtext_ajax_object.ajax_nonce,
			};

			await nxtdash_save_data(e, dataToSend);

			// Update global object with nested structure
			if (!nxtext_ajax_object.dashData.extOption) {
				nxtext_ajax_object.dashData.extOption = {};
			}
			if (!nxtext_ajax_object.dashData.extOption.nxtAiSettings) {
				nxtext_ajax_object.dashData.extOption.nxtAiSettings = {};
			}
			nxtext_ajax_object.dashData.extOption.nxtAiSettings.aiIntegrationEnabled =
				isChecked;

			toast(
				<CustomSuccessToast
					message={
						isChecked
							? "AI Integration enabled successfully!"
							: "AI Integration disabled successfully!"
					}
				/>,
				{
					position: "top-right",
					autoClose: 500,
					limit: 1,
					closeOnClick: true,
					closeButton: false,
					pauseOnHover: false,
					hideProgressBar: true,
					transition: Slide,
					className: "nxt-blocks-success-toast",
				}
			);
		} catch (error) {
			console.error("❌ Toggle save error:", error);

			toast(<CustomErrorToast message="Failed to save toggle state" />, {
				icon: false,
				position: "top-right",
				autoClose: 800,
				limit: 1,
				closeOnClick: true,
				closeButton: false,
				pauseOnHover: false,
				hideProgressBar: true,
				transition: Slide,
				className: "nxt-blocks-success-toast",
			});

			// Revert state on error
			const revertSwitch = { ...enabledSettings };
			revertSwitch[key]["switch"] = !isChecked;
			setEnabledSettings(revertSwitch);
		}
	};

	const handleModelSelect = (model) => {
		setSelectedModel(model);
	};

	const TOKEN_LIMITS = {
		chatgpt: {
			text: { min: 0, max: 128000, recommended: 4096 },
			image: { min: 0, max: 4096, recommended: 1024 },
		},
		gemini: {
			text: { min: 0, max: 2097152, recommended: 8192 },
			image: { min: 0, max: 16384, recommended: 2048 },
		},
	};

	const handleFieldChange = (field, value) => {
		// ✅ NEW: Reset verification when API key changes
		if (field === "apiKey") {
			setKeyValidationResults((prev) => ({
				...prev,
				[selectedModel]: null,
			}));

			// Reset isKeyVerified
			setEnabledSettings((prev) => ({
				...prev,
				"ai-integration-key": {
					...prev["ai-integration-key"],
					values: {
						...prev["ai-integration-key"].values,
						[selectedModel]: {
							...prev["ai-integration-key"].values[selectedModel],
							apiKey: value,
							isKeyVerified: false, // Reset verification
						},
					},
				},
			}));
			return;
		}

		// Handle token fields with validation
		if (field === "textMaxTokens" || field === "imageMaxTokens") {
			let numValue = value === "" ? 0 : Number(value);

			if (isNaN(numValue)) {
				numValue = 0;
			} else {
				const tokenType = field === "textMaxTokens" ? "text" : "image";
				const limits = TOKEN_LIMITS[selectedModel][tokenType];

				if (numValue < limits.min) {
					numValue = limits.min;
					toast(
						<CustomWarnToast
							message={`Minimum value is ${limits.min}`}
						/>,
						{
							icon: false,
							position: "top-right",
							autoClose: 800,
							limit: 1,
							closeOnClick: true,
							closeButton: false,
							pauseOnHover: false,
							hideProgressBar: true,
							transition: Slide,
							className: "nxt-blocks-success-toast",
						}
					);
				} else if (numValue > limits.max) {
					numValue = limits.max;
					toast(
						<CustomWarnToast
							message={`Maximum value for ${
								selectedModel === "chatgpt"
									? "OpenAI"
									: "Gemini"
							} ${tokenType} tokens is ${limits.max.toLocaleString()}`}
						/>,
						{
							icon: false,
							position: "top-right",
							autoClose: 800,
							limit: 1,
							closeOnClick: true,
							closeButton: false,
							pauseOnHover: false,
							hideProgressBar: true,
							transition: Slide,
							className: "nxt-blocks-success-toast",
						}
					);
				}
			}

			value = numValue;
		}

		const updatedSettings = {
			...enabledSettings,
			"ai-integration-key": {
				...enabledSettings["ai-integration-key"],
				values: {
					...enabledSettings["ai-integration-key"].values,
					[selectedModel]: {
						...enabledSettings["ai-integration-key"].values[
							selectedModel
						],
						[field]: value,
					},
				},
			},
		};
		setEnabledSettings(updatedSettings);
	};

	const handleContextFieldChange = (field, value) => {
		const updatedSettings = {
			...enabledSettings,
			"ai-Context-key": {
				...enabledSettings["ai-Context-key"],
				values: {
					...enabledSettings["ai-Context-key"].values,
					[field]: value,
				},
			},
		};
		setEnabledSettings(updatedSettings);
	};

	const handlePopupSave = async (e) => {
		if (popupData) {
			if (popupData.key === "ai-integration-key") {
				const updatedSettings = {
					...enabledSettings,
					"ai-integration-key": {
						...enabledSettings["ai-integration-key"],
						values: {
							...enabledSettings["ai-integration-key"].values,
							nxtAiModel: selectedModel,
						},
					},
				};

				setEnabledSettings(updatedSettings);

				const chatgptSettings =
					updatedSettings["ai-integration-key"].values.chatgpt;
				const geminiSettings =
					updatedSettings["ai-integration-key"].values.gemini;
				const contextData = enabledSettings["ai-Context-key"].values;

				// ✅ MERGE with existing extOption data to preserve other settings
				const existingData =
					nxtext_ajax_object?.dashData?.extOption || {};

				const dataToSend = {
					action: "tpgb_connection_data_save",
					"submit-key": "Save",
					tpgb_connection_data: JSON.stringify({
						...existingData, // ✅ Keep all existing settings

						// ✅ Nest all AI settings under nxtAiSettings
						nxtAiSettings: {
							aiIntegrationEnabled:
								updatedSettings["ai-integration-key"].switch,
							nxtAiModel: selectedModel,
							chatgptApiKey: chatgptSettings.apiKey,
							chatgptTextMaxTokens: chatgptSettings.textMaxTokens,
							chatgptEnableText: chatgptSettings.enableText,
							chatgptEnableImage: chatgptSettings.enableImage,
							chatgptKeyVerified: chatgptSettings.isKeyVerified,
							geminiApiKey: geminiSettings.apiKey,
							geminiTextMaxTokens: geminiSettings.textMaxTokens,
							geminiImageMaxTokens: geminiSettings.imageMaxTokens,
							geminiEnableText: geminiSettings.enableText,
							geminiEnableImage: geminiSettings.enableImage,
							geminiKeyVerified: geminiSettings.isKeyVerified,
							businessContext: contextData.businessContext,
							targetedAudience: contextData.targetedAudience,
						},
					}),
					nonce_tpgb_connection_data: nxtext_ajax_object.ajax_nonce,
				};

				nxtdash_save_data(e, dataToSend)
					.then((response) => {
						if (!nxtext_ajax_object.dashData.extOption) {
							nxtext_ajax_object.dashData.extOption = {};
						}
						if (
							!nxtext_ajax_object.dashData.extOption.nxtAiSettings
						) {
							nxtext_ajax_object.dashData.extOption.nxtAiSettings =
								{};
						}

						// Update nested global settings
						const aiSettings =
							nxtext_ajax_object.dashData.extOption.nxtAiSettings;
						aiSettings.aiIntegrationEnabled =
							updatedSettings["ai-integration-key"].switch;
						aiSettings.nxtAiModel = selectedModel;
						aiSettings.chatgptApiKey = chatgptSettings.apiKey;
						aiSettings.chatgptTextMaxTokens =
							chatgptSettings.textMaxTokens;
						aiSettings.chatgptEnableText =
							chatgptSettings.enableText;
						aiSettings.chatgptEnableImage =
							chatgptSettings.enableImage;
						aiSettings.chatgptKeyVerified =
							chatgptSettings.isKeyVerified;
						aiSettings.geminiApiKey = geminiSettings.apiKey;
						aiSettings.geminiTextMaxTokens =
							geminiSettings.textMaxTokens;
						aiSettings.geminiImageMaxTokens =
							geminiSettings.imageMaxTokens;
						aiSettings.geminiEnableText = geminiSettings.enableText;
						aiSettings.geminiEnableImage =
							geminiSettings.enableImage;
						aiSettings.geminiKeyVerified =
							geminiSettings.isKeyVerified;
						aiSettings.businessContext =
							contextData.businessContext;
						aiSettings.targetedAudience =
							contextData.targetedAudience;

						toast(
							<CustomSuccessToast
								message={`${
									selectedModel === "chatgpt"
										? "ChatGPT"
										: "Gemini"
								} settings saved successfully!`}
							/>,
							{
								position: "top-right",
								autoClose: 500,
								limit: 1,
								closeOnClick: true,
								closeButton: false,
								pauseOnHover: false,
								hideProgressBar: true,
								transition: Slide,
								className: "nxt-blocks-success-toast",
							}
						);
						handleClosePopup();
					})
					.catch((error) => {
						console.error("Save error:", error);
						toast(
							<CustomErrorToast message="Failed to save AI settings" />,
							{
								icon: false,
								position: "top-right",
								autoClose: 800,
								limit: 1,
								closeOnClick: true,
								closeButton: false,
								pauseOnHover: false,
								hideProgressBar: true,
								transition: Slide,
								className: "nxt-blocks-success-toast",
							}
						);
					});
			} else if (popupData.key === "ai-Context-key") {
				const contextSettings =
					enabledSettings["ai-Context-key"].values;

				if (!contextSettings.businessContext) {
					toast(
						<CustomErrorToast message="Please enter Business Context" />,
						{
							icon: false,
							position: "top-right",
							autoClose: 800,
							limit: 1,
							closeOnClick: true,
							closeButton: false,
							pauseOnHover: false,
							hideProgressBar: true,
							transition: Slide,
							className: "nxt-blocks-success-toast",
						}
					);
					return;
				}

				if (!contextSettings.targetedAudience) {
					toast(
						<CustomWarnToast message="Please enter Targeted Audience" />,
						{
							icon: false,
							position: "top-right",
							autoClose: 800,
							limit: 1,
							closeOnClick: true,
							closeButton: false,
							pauseOnHover: false,
							hideProgressBar: true,
							transition: Slide,
							className: "nxt-blocks-success-toast",
						}
					);
					return;
				}

				const aiIntegrationSettings =
					enabledSettings["ai-integration-key"].values;
				const chatgptSettings = aiIntegrationSettings.chatgpt;
				const geminiSettings = aiIntegrationSettings.gemini;

				// ✅ MERGE with existing extOption data to preserve other settings
				const existingData =
					nxtext_ajax_object?.dashData?.extOption || {};

				const dataToSend = {
					action: "tpgb_connection_data_save",
					"submit-key": "Save",
					tpgb_connection_data: JSON.stringify({
						...existingData, // ✅ Keep all existing settings

						// ✅ Nest all AI settings under nxtAiSettings
						nxtAiSettings: {
							aiIntegrationEnabled:
								enabledSettings["ai-integration-key"].switch,
							nxtAiModel: aiIntegrationSettings.nxtAiModel,
							chatgptApiKey: chatgptSettings.apiKey,
							chatgptTextMaxTokens: chatgptSettings.textMaxTokens,
							chatgptEnableText: chatgptSettings.enableText,
							chatgptEnableImage: chatgptSettings.enableImage,
							chatgptKeyVerified: chatgptSettings.isKeyVerified,
							geminiApiKey: geminiSettings.apiKey,
							geminiTextMaxTokens: geminiSettings.textMaxTokens,
							geminiImageMaxTokens: geminiSettings.imageMaxTokens,
							geminiEnableText: geminiSettings.enableText,
							geminiEnableImage: geminiSettings.enableImage,
							geminiKeyVerified: geminiSettings.isKeyVerified,
							businessContext: contextSettings.businessContext,
							targetedAudience: contextSettings.targetedAudience,
						},
					}),
					nonce_tpgb_connection_data: nxtext_ajax_object.ajax_nonce,
				};

				nxtdash_save_data(e, dataToSend)
					.then((response) => {
						if (!nxtext_ajax_object.dashData.extOption) {
							nxtext_ajax_object.dashData.extOption = {};
						}
						if (
							!nxtext_ajax_object.dashData.extOption.nxtAiSettings
						) {
							nxtext_ajax_object.dashData.extOption.nxtAiSettings =
								{};
						}

						const aiSettings =
							nxtext_ajax_object.dashData.extOption.nxtAiSettings;
						aiSettings.aiIntegrationEnabled =
							enabledSettings["ai-integration-key"].switch;
						aiSettings.businessContext =
							contextSettings.businessContext;
						aiSettings.targetedAudience =
							contextSettings.targetedAudience;

						toast(
							<CustomSuccessToast message="AI Context settings saved successfully!" />,
							{
								position: "top-right",
								autoClose: 500,
								limit: 1,
								closeOnClick: true,
								closeButton: false,
								pauseOnHover: false,
								hideProgressBar: true,
								transition: Slide,
								className: "nxt-blocks-success-toast",
							}
						);

						handleClosePopup();
					})
					.catch((error) => {
						console.error("Save error:", error);
						toast(
							<CustomErrorToast message="Failed to save AI Context settings" />,
							{
								icon: false,
								position: "top-right",
								autoClose: 800,
								limit: 1,
								closeOnClick: true,
								closeButton: false,
								pauseOnHover: false,
								hideProgressBar: true,
								transition: Slide,
								className: "nxt-blocks-success-toast",
							}
						);
					});
			}
		}
	};

	const tooltipSVG = (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z"
				stroke="#1A1A1A"
				strokeWidth="0.705882"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 9.333V7"
				stroke="#1A1A1A"
				strokeWidth="0.705882"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 4.666h.006"
				stroke="#1A1A1A"
				strokeWidth="0.705882"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	// Get current model settings for display
	const currentModelSettings = enabledSettings["ai-integration-key"]
		?.values?.[selectedModel] || {
		apiKey: "",
		textMaxTokens: 4096,
		imageMaxTokens: 2048,
		enableText: true,
		enableImage: true,
	};

	// Get AI Context settings
	const contextSettings = enabledSettings["ai-Context-key"]?.values || {
		businessContext: "",
		targetedAudience: "",
	};

	const popupContent = {
		"ai-integration-key": {
			title: __("API Key", "the-plus-addons-for-block-editor"),
			description:
				"Enter your LLM API Keys to enable AI-powered content generation.",
		},
		"ai-Context-key": {
			title: __(
				"Add Website Custom Context",
				"the-plus-addons-for-block-editor"
			),
			description:
				"Set the writing style, tone, and site-specific instructions. This context will be applied to all AI prompts to deliver more accurate and brand-aligned output. ",
		},
	};

	const isValidApiKeyFormat = (model, apiKey) => {
		if (!apiKey?.trim()) return false;

		const trimmedKey = apiKey.trim();

		if (model === "chatgpt") {
			// Old format: sk-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx (51 chars)
			const oldFormat = /^sk-[A-Za-z0-9]{48}$/;
			// New format: sk-proj-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx (minimum 56 chars)
			const newFormat = /^sk-proj-[A-Za-z0-9_-]{48,}$/;

			// Remove the length check - it's too restrictive
			return oldFormat.test(trimmedKey) || newFormat.test(trimmedKey);
		} else if (model === "gemini") {
			// Gemini keys are exactly 39 characters starting with AIza
			if (trimmedKey.length !== 39) return false;
			return /^AIza[A-Za-z0-9_-]{35}$/.test(trimmedKey);
		}

		return false;
	};
	const testApiKey = async (model, apiKey) => {
		if (!isValidApiKeyFormat(model, apiKey)) {
			setKeyValidationResults((prev) => ({
				...prev,
				[model]: "invalid",
			}));
			toast(
				<CustomErrorToast
					message={`Invalid ${
						model === "chatgpt" ? "OpenAI" : "Gemini"
					} API key format`}
				/>,
				{
					icon: false,
					position: "top-right",
					autoClose: 800,
					limit: 1,
					closeOnClick: true,
					closeButton: false,
					pauseOnHover: false,
					hideProgressBar: true,
					transition: Slide,
					className: "nxt-blocks-success-toast",
				}
			);
			return false;
		}

		setIsValidatingKeys(true);

		try {
			let response;

			if (model === "chatgpt") {
				response = await fetch("https://api.openai.com/v1/models", {
					method: "GET",
					headers: {
						Authorization: `Bearer ${apiKey}`,
						"Content-Type": "application/json",
					},
				});
			} else if (model === "gemini") {
				response = await fetch(
					`https://generativelanguage.googleapis.com/v1beta/models?key=${apiKey}`,
					{
						method: "GET",
						headers: {
							"Content-Type": "application/json",
						},
					}
				);
			}

			if (response.ok) {
				setKeyValidationResults((prev) => ({
					...prev,
					[model]: "valid",
				}));

				// ✅ NEW: Update isKeyVerified in state
				setEnabledSettings((prev) => ({
					...prev,
					"ai-integration-key": {
						...prev["ai-integration-key"],
						values: {
							...prev["ai-integration-key"].values,
							[model]: {
								...prev["ai-integration-key"].values[model],
								isKeyVerified: true,
							},
						},
					},
				}));

				// Show "Verified" for 1 second
				setVerifiedModel(model);
				setTimeout(() => {
					setVerifiedModel(null);
				}, 1000);

				toast(
					<CustomSuccessToast
						message={`${
							model === "chatgpt" ? "OpenAI" : "Gemini"
						} API key is valid!`}
					/>,
					{
						position: "top-right",
						autoClose: 500,
						limit: 1,
						closeOnClick: true,
						closeButton: false,
						pauseOnHover: false,
						hideProgressBar: true,
						transition: Slide,
						className: "nxt-blocks-success-toast",
					}
				);
				return true;
			} else {
				const errorData = await response.json();
				setKeyValidationResults((prev) => ({
					...prev,
					[model]: "invalid",
				}));

				// ✅ NEW: Set isKeyVerified to false on error
				setEnabledSettings((prev) => ({
					...prev,
					"ai-integration-key": {
						...prev["ai-integration-key"],
						values: {
							...prev["ai-integration-key"].values,
							[model]: {
								...prev["ai-integration-key"].values[model],
								isKeyVerified: false,
							},
						},
					},
				}));

				// Show "Verified" for 1 second
				setVerifiedModel(model);
				setTimeout(() => {
					setVerifiedModel(null);
				}, 1000);

				toast(
					<CustomErrorToast
						message={
							// errorData?.error?.message ||
							// errorData?.error ||
							"Invalid API key"
						}
					/>,
					{
						icon: false,
						position: "top-right",
						autoClose: 800,
						limit: 1,
						closeOnClick: true,
						closeButton: false,
						pauseOnHover: false,
						hideProgressBar: true,
						transition: Slide,
						className: "nxt-blocks-success-toast",
					}
				);
				return false;
			}
		} catch (error) {
			console.error("API key validation error:", error);
			setKeyValidationResults((prev) => ({
				...prev,
				[model]: "invalid",
			}));

			// ✅ NEW: Set isKeyVerified to false on error
			setEnabledSettings((prev) => ({
				...prev,
				"ai-integration-key": {
					...prev["ai-integration-key"],
					values: {
						...prev["ai-integration-key"].values,
						[model]: {
							...prev["ai-integration-key"].values[model],
							isKeyVerified: false,
						},
					},
				},
			}));

			toast(
				<CustomErrorToast message="Failed to validate API key. Please check your connection." />,
				{
					icon: false,
					position: "top-right",
					autoClose: 800,
					limit: 1,
					closeOnClick: true,
					closeButton: false,
					pauseOnHover: false,
					hideProgressBar: true,
					transition: Slide,
					className: "nxt-blocks-success-toast",
				}
			);
			return false;
		} finally {
			setIsValidatingKeys(false);
		}
	};

	const handleValidateApiKey = (e) => {
		e.preventDefault(); // Prevent label's default behavior
		e.stopPropagation(); // Stop event from bubbling to label

		const apiKey = currentModelSettings.apiKey;
		if (!apiKey || apiKey.trim() === "") {
			toast(<CustomWarnToast message="Please enter an API key first" />, {
				icon: false,
				position: "top-right",
				autoClose: 800,
				limit: 1,
				closeOnClick: true,
				closeButton: false,
				pauseOnHover: false,
				hideProgressBar: true,
				transition: Slide,
				className: "nxt-blocks-success-toast",
			});
			return;
		}
		testApiKey(selectedModel, apiKey);
	};

	const handleRevokeApiKey = (e) => {
		e.preventDefault();
		e.stopPropagation();

		// Clear the API key
		handleFieldChange("apiKey", "");

		// Reset verification status
		setKeyValidationResults((prev) => ({
			...prev,
			[selectedModel]: null,
		}));

		// Update isKeyVerified to false
		setEnabledSettings((prev) => ({
			...prev,
			"ai-integration-key": {
				...prev["ai-integration-key"],
				values: {
					...prev["ai-integration-key"].values,
					[selectedModel]: {
						...prev["ai-integration-key"].values[selectedModel],
						isKeyVerified: false,
					},
				},
			},
		}));

		toast(
			<CustomSuccessToast
				message={`${
					selectedModel === "chatgpt" ? "OpenAI" : "Gemini"
				} API key revoked`}
			/>,
			{
				icon: false,
				position: "top-right",
				autoClose: 800,
				limit: 1,
				closeOnClick: true,
				closeButton: false,
				pauseOnHover: false,
				hideProgressBar: true,
				transition: Slide,
				className: "nxt-blocks-success-toast",
			}
		);
	};
	useEffect(() => {
		const handleEscapeKey = (event) => {
			if (event.key === "Escape") {
				handleClosePopup();
			}
		};

		// Attach listener if ANY popup is open
		if (isPopupVisible || isProPopupVisible) {
			document.addEventListener("keydown", handleEscapeKey);
		}

		return () => {
			document.removeEventListener("keydown", handleEscapeKey);
		};
	}, [isPopupVisible, isProPopupVisible]);

	const maskApiKey = (apiKey) => {
		if (!apiKey || apiKey.trim() === "") {
			return "";
		}

		const trimmedKey = apiKey.trim();

		// Show only last 4 characters
		if (trimmedKey.length <= 4) {
			return trimmedKey;
		}

		const visiblePart = trimmedKey.slice(-4);
		const maskedLength = trimmedKey.length - 4;
		const masked = "•".repeat(maskedLength);

		return masked + visiblePart;
	};
	const plugin_url =
		nxtext_ajax_object.nxtex_url || nxtext_ajax_object.tpgb_url;

	return (
		<>
			<div className="nxtext_theme_ctm_inn_main nxtext_main_container">
				<div className="nxtext_section_heading_cover">
					<h3 className="nxtext_primary_heading">
						{__(
							"AI Integration",
							"the-plus-addons-for-block-editor"
						)}
					</h3>
				</div>
				<div className="nxtext_theme_cstm_crds_cover">
					{Theme_cstm_crds.map((item) => (
						<div className="nxtext_field_card" key={item.name}>
							<div className="nxtext_card_top_detail">
								<div className="nxtext_field_card_h_strip">
									<div className="nxtext_excrd_h_cover">
										<h4 className="nxtext_secondary_heading">
											{item.name}
										</h4>
										<div className="nxtext_tooltip">
											{tooltipSVG}
											<span className="nxtext_tooltiptext">
												{item.crd_desc}
											</span>
										</div>
									</div>
									<div className="nxtext-extra-tgl-wrap">
										<button
											className={
												"nxtext_ex_btn" +
												(enabledSettings[
													"ai-integration-key"
												]?.switch // Check AI Integration toggle
													? " enabled"
													: " disabled")
											}
											onClick={() => {
												handleOpenPopup(item);
											}}
											disabled={
												!enabledSettings[
													"ai-integration-key"
												]?.switch
											} // Disable if AI Integration is off
											style={{
												cursor: !enabledSettings[
													"ai-integration-key"
												]?.switch
													? "not-allowed"
													: "pointer",
												opacity: !enabledSettings[
													"ai-integration-key"
												]?.switch
													? 0.5
													: 1,
											}}
										>
											{nxtds_icons.setting}
										</button>

										{item.key !== "ai-Context-key" && (
											<div className="nxtext_block_tgl_btn_cover">
												<input
													className="nxtext_toggle_btn"
													id={`nxt_${item.key}_toggle`}
													checked={
														enabledSettings[
															item.key
														]?.switch
															? true
															: false
													}
													type="checkbox"
													onChange={(e) => {
														handleCheckboxChange(
															e,
															item.key,
															"extra"
														);
													}}
												/>

												<label
													className="nxtext_switch_label"
													htmlFor={`nxt_${item.key}_toggle`}
												>
													<span className="nxtext_switch_button"></span>
												</label>
											</div>
										)}
									</div>
								</div>
								{item.read_link &&
									!(
										nxtext_ajax_object?.dashData?.whiteLabel
											?.nxt_help_link == "on"
									) && (
										<div className="nxtext_links_cover">
											<a
												target="_blank"
												rel="noopener noreferrer"
												href={item.read_link || "#"}
												className="nxtext_tertiary_btn nxtext_paragraph"
											>
												{__(
													"Read Docs",
													"the-plus-addons-for-block-editor"
												)}
											</a>
										</div>
									)}
							</div>
						</div>
					))}
				</div>

				{/* AI Settings Popup */}
				{isPopupVisible && (
					<div>
						<>
							<div
								className="nxtext_overlay"
								onClick={handleClosePopup}
							></div>
							<div
								className={`nxtext_settings_popup ${extType}-popup`}
							>
								<svg
									className="nxtext_close_icon"
									draggable={false}
									onClick={handleClosePopup}
									xmlns="http://www.w3.org/2000/svg"
									width="36"
									height="17"
									fill="none"
									viewBox="0 0 36 17"
								>
									<path
										fill="#414B5A"
										d="M22.2 4.30665c-.26-.26-.68-.26-.94 0L18 7.55998l-3.26-3.26c-.26-.26-.68-.26-.94 0-.26.26-.26.68 0 .94l3.26 3.26L13.8 11.76c-.26.26-.26.68 0 .94.26.26.68.26.94 0L18 9.43998 21.26 12.7c.26.26.68.26.94 0 .26-.26.26-.68 0-.94l-3.26-3.26002 3.26-3.26c.2533-.25333.2533-.68 0-.93333Z"
									/>
								</svg>

								<div className="nxtext_popup_heading">
									<h3 className="nxtext_primary_heading">
										{popupContent[popupData.key]?.title}
									</h3>
									<p
										className="nxtext_paragrph"
										dangerouslySetInnerHTML={{
											__html: popupContent[popupData.key]
												?.description,
										}}
									></p>
								</div>

								<div className="nxtext_popup_inner_main_co">
									<div className="nxtext_field_card_cover">
										<div className="nxtext_pop_in_cover">
											<div className="nxtext_field_wrap">
												{/* AI Integration Settings */}
												{popupData.key ===
													"ai-integration-key" && (
													<>
														{/* Model Selection */}
														<div className="nxtext_field_with_lbl nxt-ai-compatibility">
															<div className="nxtext_tab_radio_wrap">
																<div className="nxtext_radio_inner_div">
																	<input
																		type="radio"
																		id="ai-model-chatgpt"
																		value="chatgpt"
																		name="ai-model"
																		className="nxtext_radio_field"
																		checked={
																			selectedModel ===
																			"chatgpt"
																		}
																		onChange={() =>
																			handleModelSelect(
																				"chatgpt"
																			)
																		}
																	/>
																	<label
																		htmlFor="ai-model-chatgpt"
																		className="nxtext_paragrph"
																	>
																		{__(
																			"OpenAI",
																			"the-plus-addons-for-block-editor"
																		)}
																	</label>
																</div>

																<div className="nxtext_radio_inner_div">
																	<input
																		type="radio"
																		id="ai-model-gemini"
																		value="gemini"
																		name="ai-model"
																		className="nxtext_radio_field"
																		checked={
																			selectedModel ===
																			"gemini"
																		}
																		onChange={() =>
																			handleModelSelect(
																				"gemini"
																			)
																		}
																	/>
																	<label
																		htmlFor="ai-model-gemini"
																		className="nxtext_paragrph"
																	>
																		{__(
																			"Google Gemini",
																			"the-plus-addons-for-block-editor"
																		)}
																	</label>
																</div>
															</div>
														</div>

														{/* Settings Container - Changes based on selected model */}
														<div className="nxtext_model_settings_container">
															{selectedModel ===
																"chatgpt" && (
																<>
																	{/* ChatGPT API Key */}
																	<div className="nxtext_field_wrap">
																		<div className="nxtext_field_with_lbl nxt-ai-compatibility">
																			<label
																				// htmlFor="chatgpt_api_key"
																				className="nxtext_secondary_heading"
																			>
																				{__(
																					"API Key",
																					"the-plus-addons-for-block-editor"
																				)}
																			</label>
																			<div className="nxt-ai-api-check">
																				<input
																					type="text"
																					id="chatgpt_api_key"
																					className="nxtext_text_field"
																					value={
																						currentModelSettings.isKeyVerified
																							? maskApiKey(
																									currentModelSettings.apiKey
																							  )
																							: currentModelSettings.apiKey
																					}
																					placeholder={__(
																						"sk-proj-...",
																						"the-plus-addons-for-block-editor"
																					)}
																					onChange={(
																						e
																					) =>
																						handleFieldChange(
																							"apiKey",
																							e
																								.target
																								.value
																						)
																					}
																				/>
																				<button
																					className={
																						currentModelSettings.isKeyVerified
																							? "nxtext_ai_revoke_btn"
																							: "nxtext_blue_common_btn"
																					}
																					onClick={
																						currentModelSettings.isKeyVerified
																							? handleRevokeApiKey
																							: handleValidateApiKey
																					}
																					disabled={
																						isValidatingKeys
																					}
																					style={{
																						opacity:
																							isValidatingKeys
																								? 0.7
																								: 1,
																						cursor: isValidatingKeys
																							? "not-allowed"
																							: "pointer",
																					}}
																				>
																					{isValidatingKeys &&
																					selectedModel ===
																						"chatgpt" ? (
																						<span className="nxtext-loading-circle"></span>
																					) : currentModelSettings.isKeyVerified ? (
																						"Revoke"
																					) : verifiedModel ===
																					  "chatgpt" ? (
																						"Verified"
																					) : (
																						"Verify"
																					)}
																				</button>
																			</div>
																			<div className="nxt-ai-compatibility nxt-ai-link">
																				{!currentModelSettings.isKeyVerified && (
																					<a
																						href="https://help.openai.com/en/articles/4936850-where-do-i-find-my-openai-api-key"
																						className="nxt-ai-link"
																						target="_blank"
																						rel="noopener noreferrer"
																					>
																						How
																						to
																						get
																						API
																						Key?
																					</a>
																				)}

																				{currentModelSettings.apiKey &&
																					currentModelSettings.isKeyVerified && (
																						<>
																							<a
																								href="https://platform.openai.com/docs/api-reference/introduction"
																								className="nxt-ai-link"
																								target="_blank"
																								rel="noopener noreferrer"
																							>
																								Manage
																								API
																								Key
																							</a>
																							<span>
																								|
																							</span>
																							<a
																								href="https://platform.openai.com/api-keys"
																								className="nxt-ai-link"
																								target="_blank"
																								rel="noopener noreferrer"
																							>
																								Usage
																								History
																							</a>
																						</>
																					)}
																			</div>
																		</div>

																		{/* ChatGPT Feature Toggles */}
																		<div className="nxtext-toggle-flex">
																			<div className="nxtext_strip_tgl_cover nxt-ai-compatibility">
																				<div className="nxtext_strip_tgl_h">
																					<label
																						className="nxtext_paragrph"
																						htmlFor="chatgpt_enable_text"
																						style={{
																							opacity:
																								currentModelSettings.isKeyVerified
																									? 1
																									: 0.5,
																							cursor: currentModelSettings.isKeyVerified
																								? "pointer"
																								: "not-allowed",
																						}}
																					>
																						{__(
																							"Text Generation",
																							"the-plus-addons-for-block-editor"
																						)}
																					</label>
																					<div className="nxtext_tooltip">
																						{
																							tooltipSVG
																						}
																						<span className="nxtext_tooltiptext">
																							{__(
																								" Enable to allow OpenAI for text generation.",
																								"the-plus-addons-for-block-editor"
																							)}
																						</span>
																					</div>
																				</div>
																				<div className="nxtext_tgl_with_setting">
																					<div className="nxtext_block_tgl_btn_cover">
																						<input
																							className="nxtext_toggle_btn"
																							id="chatgpt_enable_text"
																							type="checkbox"
																							onChange={(
																								e
																							) => {
																								// ✅ NEW: Prevent change if key not verified
																								if (
																									!currentModelSettings.isKeyVerified
																								) {
																									toast(
																										<CustomWarnToast message="Please verify your API key first" />,
																										{
																											icon: false,
																											position:
																												"top-right",
																											autoClose: 800,
																											limit: 1,
																											closeOnClick: true,
																											closeButton: false,
																											pauseOnHover: false,
																											hideProgressBar: true,
																											transition:
																												Slide,
																											className:
																												"nxt-blocks-success-toast",
																										}
																									);
																									return;
																								}
																								handleFieldChange(
																									"enableText",
																									e
																										.target
																										.checked
																								);
																							}}
																							checked={
																								currentModelSettings.enableText
																							}
																							disabled={
																								!currentModelSettings.isKeyVerified
																							} // ✅ NEW: Disable if not verified
																							style={{
																								opacity:
																									currentModelSettings.isKeyVerified
																										? 1
																										: 0.5,
																								cursor: currentModelSettings.isKeyVerified
																									? "pointer"
																									: "not-allowed",
																							}}
																						/>
																						<label
																							className="nxtext_switch_label"
																							htmlFor="chatgpt_enable_text"
																							style={{
																								opacity:
																									currentModelSettings.isKeyVerified
																										? 1
																										: 0.5,
																								cursor: currentModelSettings.isKeyVerified
																									? "pointer"
																									: "not-allowed",
																							}}
																						>
																							<span className="nxtext_switch_button"></span>
																						</label>
																					</div>
																				</div>
																			</div>

																			<div className="nxtext_strip_tgl_cover nxt-ai-compatibility">
																				<div className="nxtext_strip_tgl_h">
																					<label
																						className="nxtext_paragrph"
																						htmlFor="chatgpt_enable_image"
																						style={{
																							opacity:
																								currentModelSettings.isKeyVerified
																									? 1
																									: 0.5,
																							cursor: currentModelSettings.isKeyVerified
																								? "pointer"
																								: "not-allowed",
																						}}
																						onClick={(
																							e
																						) => {
																							if (
																								!isPro
																							) {
																								e.preventDefault();
																								setIsProPopupVisible(
																									true
																								);
																								return;
																							}
																						}}
																					>
																						{__(
																							"Image Generation",
																							"the-plus-addons-for-block-editor"
																						)}
																					</label>
																					<div className="nxtext_tooltip">
																						{
																							tooltipSVG
																						}
																						<span className="nxtext_tooltiptext">
																							{__(
																								"Enable to allow OpenAI for image generation.",
																								"the-plus-addons-for-block-editor"
																							)}
																						</span>
																					</div>
																				</div>
																				<div className="nxtext_tgl_with_setting">
																					<div className="nxtext_block_tgl_btn_cover">
																						<input
																							className="nxtext_toggle_btn"
																							id="chatgpt_enable_image"
																							type="checkbox"
																							onChange={(
																								e
																							) => {
																								// ✅ NEW: Prevent change if key not verified

																								if (
																									!currentModelSettings.isKeyVerified
																								) {
																									toast(
																										<CustomWarnToast message="Please verify your API key first" />,
																										{
																											icon: false,
																											position:
																												"top-right",
																											autoClose: 800,
																											limit: 1,
																											closeOnClick: true,
																											closeButton: false,
																											pauseOnHover: false,
																											hideProgressBar: true,
																											transition:
																												Slide,
																											className:
																												"nxt-blocks-success-toast",
																										}
																									);
																									return;
																								}
																								handleFieldChange(
																									"enableImage",
																									e
																										.target
																										.checked
																								);
																							}}
																							checked={
																								currentModelSettings.enableImage
																							}
																							disabled={
																								!isPro ||
																								!currentModelSettings.isKeyVerified
																							} // ✅ NEW: Disable if not verified
																							style={{
																								opacity:
																									!isPro &&
																									currentModelSettings.isKeyVerified
																										? 1
																										: 0.5,
																								cursor: currentModelSettings.isKeyVerified
																									? "pointer"
																									: "not-allowed",
																							}}
																						/>
																						<label
																							className="nxtext_switch_label"
																							htmlFor="chatgpt_enable_image"
																							style={{
																								opacity:
																									currentModelSettings.isKeyVerified
																										? 1
																										: 0.5,
																								cursor: currentModelSettings.isKeyVerified
																									? "pointer"
																									: "not-allowed",
																							}}
																							onClick={(
																								e
																							) => {
																								if (
																									!isPro
																								) {
																									e.preventDefault();
																									setIsProPopupVisible(
																										true
																									);
																									return;
																								}
																							}}
																						>
																							<span className="nxtext_switch_button"></span>
																						</label>
																						{!isPro && (
																							<img
																								className="nxt_toggle_lock_icon"
																								src={
																									plugin_url +
																									"assets/svg/nxt_lock_icon.svg"
																								}
																								onClick={(
																									e
																								) => {
																									if (
																										!isPro
																									) {
																										e.preventDefault();
																										setIsProPopupVisible(
																											true
																										);
																										return;
																									}
																								}}
																							/>
																						)}
																					</div>
																				</div>
																			</div>

																			{currentModelSettings.enableText && (
																				<div className="nxtext_field_with_lbl nxt-ai-compatibility">
																					<label
																						htmlFor="chatgpt_text_max_tokens"
																						className="nxtext_secondary_heading nxt-ai-compatibility"
																					>
																						{__(
																							"Max Text Tokens per Prompt",
																							"the-plus-addons-for-block-editor"
																						)}
																						<div className="nxtext_tooltip">
																							{
																								tooltipSVG
																							}
																							<span className="nxtext_tooltiptext">
																								{__(
																									"Number of tokens allowed per prompt. If a generation exceeds this limit, the process will stop to prevent excessive usage. Set 0 for no limit.",
																									"the-plus-addons-for-block-editor"
																								)}
																							</span>
																						</div>
																					</label>
																					<input
																						type="number"
																						id="chatgpt_text_max_tokens"
																						className="nxtext_text_field"
																						placeholder="4096"
																						value={
																							currentModelSettings.textMaxTokens
																						}
																						onChange={(
																							e
																						) =>
																							handleFieldChange(
																								"textMaxTokens",
																								e
																									.target
																									.value
																							)
																						}
																						onKeyPress={(
																							e
																						) => {
																							// Prevent minus, plus, e, E
																							if (
																								e.key ===
																									"-" ||
																								e.key ===
																									"+" ||
																								e.key ===
																									"e" ||
																								e.key ===
																									"E"
																							) {
																								e.preventDefault();
																							}
																						}}
																						min={
																							TOKEN_LIMITS
																								.chatgpt
																								.text
																								.min
																						}
																						max={
																							TOKEN_LIMITS
																								.chatgpt
																								.text
																								.max
																						}
																					/>
																				</div>
																			)}
																		</div>
																	</div>
																</>
															)}

															{selectedModel ===
																"gemini" && (
																<>
																	{/* Gemini API Key */}
																	<div className="nxtext_field_wrap">
																		<div className="nxtext_field_with_lbl nxt-ai-compatibility">
																			<label
																				htmlFor="gemini_api_key"
																				className="nxtext_secondary_heading"
																			>
																				{__(
																					"API Key",
																					"the-plus-addons-for-block-editor"
																				)}
																			</label>
																			<div className="nxt-ai-api-check">
																				<input
																					type="text"
																					id="gemini_api_key"
																					className="nxtext_text_field"
																					value={
																						currentModelSettings.isKeyVerified
																							? maskApiKey(
																									currentModelSettings.apiKey
																							  )
																							: currentModelSettings.apiKey
																					}
																					placeholder={__(
																						"AIza...",
																						"the-plus-addons-for-block-editor"
																					)}
																					onChange={(
																						e
																					) =>
																						handleFieldChange(
																							"apiKey",
																							e
																								.target
																								.value
																						)
																					}
																				/>
																				<button
																					className={
																						currentModelSettings.isKeyVerified
																							? "nxtext_ai_revoke_btn"
																							: "nxtext_blue_common_btn"
																					}
																					onClick={
																						currentModelSettings.isKeyVerified
																							? handleRevokeApiKey
																							: handleValidateApiKey
																					}
																					disabled={
																						isValidatingKeys
																					}
																					style={{
																						opacity:
																							isValidatingKeys
																								? 0.7
																								: 1,
																						cursor: isValidatingKeys
																							? "not-allowed"
																							: "pointer",
																					}}
																				>
																					{isValidatingKeys &&
																					selectedModel ===
																						"gemini" ? (
																						<span className="nxtext-loading-circle"></span>
																					) : currentModelSettings.isKeyVerified ? (
																						"Revoke"
																					) : verifiedModel ===
																					  "gemini" ? (
																						"Verified"
																					) : (
																						"Verify"
																					)}
																				</button>
																			</div>
																			<div className="nxt-ai-compatibility nxt-ai-link">
																				{!currentModelSettings.isKeyVerified && (
																					<a
																						href="https://ai.google.dev/gemini-api/docs/api-key"
																						className="nxt-ai-link"
																						target="_blank"
																						rel="noopener noreferrer"
																					>
																						How
																						to
																						get
																						API
																						Key?
																					</a>
																				)}

																				{currentModelSettings.apiKey &&
																					currentModelSettings.isKeyVerified && (
																						<>
																							<a
																								href="https://ai.google.dev/gemini-api/docs"
																								className="nxt-ai-link"
																								target="_blank"
																								rel="noopener noreferrer"
																							>
																								Manage
																								API
																								Key
																							</a>
																							<span>
																								|
																							</span>
																							<a
																								href="https://docs.cloud.google.com/vertex-ai/generative-ai/docs/start/api-keys?usertype=expressmode"
																								className="nxt-ai-link"
																								target="_blank"
																								rel="noopener noreferrer"
																							>
																								Usage
																								History
																							</a>
																						</>
																					)}
																			</div>
																		</div>

																		{/* Gemini Feature Toggles */}
																		<div className="nxtext-toggle-flex">
																			<div className="nxtext_strip_tgl_cover nxt-ai-compatibility">
																				<div className="nxtext_strip_tgl_h">
																					<label
																						className="nxtext_paragrph"
																						htmlFor="gemini_enable_text"
																						style={{
																							opacity:
																								currentModelSettings.isKeyVerified
																									? 1
																									: 0.5,
																							cursor: currentModelSettings.isKeyVerified
																								? "pointer"
																								: "not-allowed",
																						}}
																					>
																						{__(
																							"Text Generation",
																							"the-plus-addons-for-block-editor"
																						)}
																					</label>
																					<div className="nxtext_tooltip">
																						{
																							tooltipSVG
																						}
																						<span className="nxtext_tooltiptext">
																							{__(
																								" Enable to allow Gemini for text generation.",
																								"the-plus-addons-for-block-editor"
																							)}
																						</span>
																					</div>
																				</div>
																				<div className="nxtext_tgl_with_setting">
																					<div className="nxtext_block_tgl_btn_cover">
																						<input
																							className="nxtext_toggle_btn"
																							id="gemini_enable_text"
																							type="checkbox"
																							onChange={(
																								e
																							) => {
																								// ✅ NEW: Prevent change if key not verified
																								if (
																									!currentModelSettings.isKeyVerified
																								) {
																									toast(
																										<CustomWarnToast message="Please verify your API key first" />,
																										{
																											icon: false,
																											position:
																												"top-right",
																											autoClose: 800,
																											limit: 1,
																											closeOnClick: true,
																											closeButton: false,
																											pauseOnHover: false,
																											hideProgressBar: true,
																											transition:
																												Slide,
																											className:
																												"nxt-blocks-success-toast",
																										}
																									);
																									return;
																								}
																								handleFieldChange(
																									"enableText",
																									e
																										.target
																										.checked
																								);
																							}}
																							checked={
																								currentModelSettings.enableText
																							}
																							disabled={
																								!currentModelSettings.isKeyVerified
																							} // ✅ NEW: Disable if not verified
																							style={{
																								opacity:
																									currentModelSettings.isKeyVerified
																										? 1
																										: 0.5,
																								cursor: currentModelSettings.isKeyVerified
																									? "pointer"
																									: "not-allowed",
																							}}
																						/>
																						<label
																							className="nxtext_switch_label"
																							htmlFor="gemini_enable_text"
																							style={{
																								opacity:
																									currentModelSettings.isKeyVerified
																										? 1
																										: 0.5,
																								cursor: currentModelSettings.isKeyVerified
																									? "pointer"
																									: "not-allowed",
																							}}
																						>
																							<span className="nxtext_switch_button"></span>
																						</label>
																					</div>
																				</div>
																			</div>

																			<div className="nxtext_strip_tgl_cover nxt-ai-compatibility">
																				<div className="nxtext_strip_tgl_h">
																					<label
																						className="nxtext_paragrph"
																						htmlFor="gemini_enable_image"
																						style={{
																							opacity:
																								currentModelSettings.isKeyVerified
																									? 1
																									: 0.5,
																							cursor: currentModelSettings.isKeyVerified
																								? "pointer"
																								: "not-allowed",
																						}}
																						onClick={(
																							e
																						) => {
																							if (
																								!isPro
																							) {
																								e.preventDefault();
																								setIsProPopupVisible(
																									true
																								);
																								return;
																							}
																						}}
																					>
																						{__(
																							"Image Generation",
																							"the-plus-addons-for-block-editor"
																						)}
																					</label>
																					<div className="nxtext_tooltip">
																						{
																							tooltipSVG
																						}
																						<span className="nxtext_tooltiptext">
																							{__(
																								"Enable Gemini image generation",
																								"the-plus-addons-for-block-editor"
																							)}
																						</span>
																					</div>
																				</div>
																				<div className="nxtext_tgl_with_setting">
																					<div className="nxtext_block_tgl_btn_cover">
																						<input
																							className="nxtext_toggle_btn"
																							id="gemini_enable_image"
																							type="checkbox"
																							onChange={(
																								e
																							) => {
																								// ✅ NEW: Prevent change if key not verified
																								if (
																									!currentModelSettings.isKeyVerified
																								) {
																									toast(
																										<CustomWarnToast message="Please verify your API key first" />,
																										{
																											icon: false,
																											position:
																												"top-right",
																											autoClose: 800,
																											limit: 1,
																											closeOnClick: true,
																											closeButton: false,
																											pauseOnHover: false,
																											hideProgressBar: true,
																											transition:
																												Slide,
																											className:
																												"nxt-blocks-success-toast",
																										}
																									);
																									return;
																								}
																								handleFieldChange(
																									"enableImage",
																									e
																										.target
																										.checked
																								);
																							}}
																							checked={
																								currentModelSettings.enableImage
																							}
																							disabled={
																								!isPro ||
																								!currentModelSettings.isKeyVerified
																							} // ✅ NEW: Disable if not verified
																							style={{
																								opacity:
																									!isPro &&
																									currentModelSettings.isKeyVerified
																										? 1
																										: 0.5,
																								cursor: currentModelSettings.isKeyVerified
																									? "pointer"
																									: "not-allowed",
																							}}
																						/>
																						<label
																							className="nxtext_switch_label"
																							htmlFor="gemini_enable_image"
																							style={{
																								opacity:
																									currentModelSettings.isKeyVerified
																										? 1
																										: 0.5,
																								cursor: currentModelSettings.isKeyVerified
																									? "pointer"
																									: "not-allowed",
																							}}
																							onClick={(
																								e
																							) => {
																								if (
																									!isPro
																								) {
																									e.preventDefault();
																									setIsProPopupVisible(
																										true
																									);
																									return;
																								}
																							}}
																						>
																							<span className="nxtext_switch_button"></span>
																						</label>
																						{!isPro && (
																							<img
																								className="nxt_toggle_lock_icon"
																								src={
																									plugin_url +
																									"assets/svg/nxt_lock_icon.svg"
																								}
																								onClick={(
																									e
																								) => {
																									if (
																										!isPro
																									) {
																										e.preventDefault();
																										setIsProPopupVisible(
																											true
																										);
																										return;
																									}
																								}}
																							/>
																						)}
																					</div>
																				</div>
																			</div>

																			{currentModelSettings.enableText && (
																				<div className="nxtext_field_with_lbl nxt-ai-compatibility">
																					<label
																						htmlFor="gemini_text_max_tokens"
																						className="nxtext_secondary_heading nxt-ai-compatibility"
																					>
																						{__(
																							"Max Text Tokens per Prompt",
																							"the-plus-addons-for-block-editor"
																						)}
																						<div className="nxtext_tooltip">
																							{
																								tooltipSVG
																							}
																							<span className="nxtext_tooltiptext">
																								{__(
																									"Number of tokens allowed per prompt. If a generation exceeds this limit, the process will stop to prevent excessive usage. Set 0 for no limit.",
																									"the-plus-addons-for-block-editor"
																								)}
																							</span>
																						</div>
																					</label>
																					<input
																						type="number"
																						id="gemini_text_max_tokens"
																						className="nxtext_text_field"
																						placeholder="4096"
																						value={
																							currentModelSettings.textMaxTokens
																						}
																						onChange={(
																							e
																						) =>
																							handleFieldChange(
																								"textMaxTokens",
																								e
																									.target
																									.value
																							)
																						}
																						onKeyPress={(
																							e
																						) => {
																							if (
																								e.key ===
																									"-" ||
																								e.key ===
																									"+" ||
																								e.key ===
																									"e" ||
																								e.key ===
																									"E"
																							) {
																								e.preventDefault();
																							}
																						}}
																						min={
																							TOKEN_LIMITS
																								.gemini
																								.text
																								.min
																						}
																						max={
																							TOKEN_LIMITS
																								.gemini
																								.text
																								.max
																						}
																					/>
																				</div>
																			)}

																			{currentModelSettings.enableImage && (
																				<div className="nxtext_field_with_lbl nxt-ai-compatibility">
																					<label
																						htmlFor="gemini_image_max_tokens"
																						className="nxtext_secondary_heading nxt-ai-compatibility"
																					>
																						{__(
																							"Max Image Tokens per Prompt",
																							"the-plus-addons-for-block-editor"
																						)}
																						<div className="nxtext_tooltip">
																							{
																								tooltipSVG
																							}
																							<span className="nxtext_tooltiptext">
																								{__(
																									"Number of tokens allowed per prompt. If a generation exceeds this limit, the process will stop to prevent excessive usage. Set 0 for no limit.",
																									"the-plus-addons-for-block-editor"
																								)}
																							</span>
																						</div>
																					</label>
																					<input
																						type="number"
																						id="gemini_image_max_tokens"
																						className="nxtext_text_field"
																						placeholder="2048"
																						value={
																							currentModelSettings.imageMaxTokens
																						}
																						onChange={(
																							e
																						) =>
																							handleFieldChange(
																								"imageMaxTokens",
																								e
																									.target
																									.value
																							)
																						}
																						onKeyPress={(
																							e
																						) => {
																							if (
																								e.key ===
																									"-" ||
																								e.key ===
																									"+" ||
																								e.key ===
																									"e" ||
																								e.key ===
																									"E"
																							) {
																								e.preventDefault();
																							}
																						}}
																						min={
																							TOKEN_LIMITS
																								.gemini
																								.image
																								.min
																						}
																						max={
																							TOKEN_LIMITS
																								.gemini
																								.image
																								.max
																						}
																					/>
																				</div>
																			)}
																		</div>
																	</div>
																</>
															)}
														</div>
													</>
												)}

												{/* AI Context Settings */}
												{popupData.key ===
													"ai-Context-key" && (
													<>
														<div className="nxtext_field_wrap">
															{/* Business Context Field */}
															<div className="nxtext_field_with_lbl nxt-ai-compatibility">
																<label
																	htmlFor="business_context"
																	className="nxtext_secondary_heading nxt-ai-compatibility"
																>
																	{__(
																		"About Business",
																		"the-plus-addons-for-block-editor"
																	)}
																	<div className="nxtext_tooltip">
																		{
																			tooltipSVG
																		}
																		<span className="nxtext_tooltiptext">
																			{__(
																				"Describe your business, offerings, positioning, and unique value propositions. The AI will use this to generate content aligned with your brand identity and messaging.",
																				"the-plus-addons-for-block-editor"
																			)}
																		</span>
																	</div>
																</label>
																<textarea
																	id="business_context"
																	className="nxtext_text_field"
																	rows="4"
																	value={
																		contextSettings.businessContext
																	}
																	placeholder={__(
																		"Describe your business, industry, products/services...",
																		"the-plus-addons-for-block-editor"
																	)}
																	onChange={(
																		e
																	) =>
																		handleContextFieldChange(
																			"businessContext",
																			e
																				.target
																				.value
																		)
																	}
																/>
															</div>

															{/* Targeted Audience Field */}
															<div className="nxtext_field_with_lbl nxt-ai-compatibility">
																<label
																	htmlFor="targeted_audience"
																	className="nxtext_secondary_heading nxt-ai-compatibility"
																>
																	{__(
																		"About Target Audience",
																		"the-plus-addons-for-block-editor"
																	)}
																	<div className="nxtext_tooltip">
																		{
																			tooltipSVG
																		}
																		<span className="nxtext_tooltiptext">
																			{__(
																				"Explain who your audience is their needs, demographics, preferences, and goals. This helps the AI tailor tone, depth, and content style to the right user group.",
																				"the-plus-addons-for-block-editor"
																			)}
																		</span>
																	</div>
																</label>
																<textarea
																	id="targeted_audience"
																	className="nxtext_text_field"
																	rows="4"
																	value={
																		contextSettings.targetedAudience
																	}
																	placeholder={__(
																		"Describe your target audience demographics, interests, pain points...",
																		"the-plus-addons-for-block-editor"
																	)}
																	onChange={(
																		e
																	) =>
																		handleContextFieldChange(
																			"targetedAudience",
																			e
																				.target
																				.value
																		)
																	}
																/>
															</div>
														</div>
													</>
												)}
											</div>
										</div>
									</div>
								</div>

								<div className="nxtext_popup_bottom">
									{popupData.doclink &&
										popupData.doclink !== "#" && (
											<a
												className="nxtext_tertiary_btn"
												target="_blank"
												rel="noopener noreferrer"
												href={popupData.doclink}
											>
												{__(
													"Read How it Works",
													"the-plus-addons-for-block-editor"
												)}
											</a>
										)}
									<button
										className="nxtext_blue_common_btn"
										onClick={handlePopupSave}
									>
										{__(
											"Save",
											"the-plus-addons-for-block-editor"
										)}
									</button>
								</div>
							</div>
						</>
					</div>
				)}
				<ToastContainer
					position="top-right"
					autoClose={500}
					limit={1}
					closeOnClick={true}
					closeButton={false}
					pauseOnHover={false}
					hideProgressBar={true}
					transition={Slide}
				/>
			</div>
		</>
	);
};

export default AI_Compatibility;
